import { isEmpty } from 'bold-ui'
import { SimNaoEnum } from 'components/form'
import { Calculation } from 'final-form-calculate'
import { metaPath } from 'util/metaPath'

import { ConsultaSeguimentoFieldModel } from './model-consultaSeguimento'
import { ConsultaSeguimentoPergunta02Model } from './perguntas/consulta-seguimento-pergunta-02/model-consultaSeguimentoPergunta02'

const meta = metaPath<ConsultaSeguimentoFieldModel>()

export const consultaSeguimentoCalculator: Calculation[] = [
  {
    field: meta.aplicacao.PERGUNTA_02.PERGUNTA_02_FEZ_EXAME.absolutePath(),
    updates: {
      [meta.aplicacao.PERGUNTA_02.PERGUNTA_02_RESULTADO_EXAME.absolutePath()]: (
        value: ConsultaSeguimentoPergunta02Model['PERGUNTA_02_FEZ_EXAME'],
        allValues: ConsultaSeguimentoFieldModel
      ) => {
        if (value !== SimNaoEnum.SIM) {
          return null
        }
        return allValues.aplicacao?.PERGUNTA_02?.PERGUNTA_02_RESULTADO_EXAME
      },
    },
  },
  {
    field: meta.aplicacao.PERGUNTA_03.OUTRO.valor.absolutePath(),
    updates: {
      [meta.aplicacao.PERGUNTA_03.OUTRO.selecionado.absolutePath()]: (
        value: string,
        allValues: ConsultaSeguimentoFieldModel
      ) => {
        if (isEmpty(value)) {
          return null
        }
        return allValues.aplicacao?.PERGUNTA_03?.OUTRO?.selecionado
      },
    },
  },
  {
    field: meta.aplicacao.PERGUNTA_05.OUTRO.valor.absolutePath(),
    updates: {
      [meta.aplicacao.PERGUNTA_05.OUTRO.selecionado.absolutePath()]: (
        value: string,
        allValues: ConsultaSeguimentoFieldModel
      ) => {
        if (isEmpty(value)) {
          return null
        }
        return allValues.aplicacao?.PERGUNTA_05?.OUTRO?.selecionado
      },
    },
  },
  {
    field: meta.aplicacao.PERGUNTA_09.OUTRO.valor.absolutePath(),
    updates: {
      [meta.aplicacao.PERGUNTA_09.OUTRO.selecionado.absolutePath()]: (
        value: string,
        allValues: ConsultaSeguimentoFieldModel
      ) => {
        if (isEmpty(value)) {
          return null
        }
        return allValues.aplicacao?.PERGUNTA_09?.OUTRO?.selecionado
      },
    },
  },
  {
    field: meta.aplicacao.PERGUNTA_12.OUTRO.valor.absolutePath(),
    updates: {
      [meta.aplicacao.PERGUNTA_12.OUTRO.selecionado.absolutePath()]: (
        value: string,
        allValues: ConsultaSeguimentoFieldModel
      ) => {
        if (isEmpty(value)) {
          return null
        }
        return allValues.aplicacao?.PERGUNTA_12?.OUTRO?.selecionado
      },
    },
  },
  {
    field: meta.aplicacao.PERGUNTA_15.OUTRO.valor.absolutePath(),
    updates: {
      [meta.aplicacao.PERGUNTA_15.OUTRO.selecionado.absolutePath()]: (
        value: string,
        allValues: ConsultaSeguimentoFieldModel
      ) => {
        if (isEmpty(value)) {
          return null
        }
        return allValues.aplicacao?.PERGUNTA_15?.OUTRO?.selecionado
      },
    },
  },
  {
    field: meta.aplicacao.PERGUNTA_17.OUTRO.valor.absolutePath(),
    updates: {
      [meta.aplicacao.PERGUNTA_17.OUTRO.selecionado.absolutePath()]: (
        value: string,
        allValues: ConsultaSeguimentoFieldModel
      ) => {
        if (isEmpty(value)) {
          return null
        }
        return allValues.aplicacao?.PERGUNTA_17?.OUTRO?.selecionado
      },
    },
  },
]
